module.exports = __webpack_public_path__ + "static/media/my-clients.13bd16e5.svg";